module.exports = __webpack_public_path__ + "img/online.28f2795b.svg";